import React from 'react'
import PropTypes from 'prop-types'

import { Table, Typography } from 'antd'

const columns = [
  {
    title: 'Pros',
    dataIndex: 'pros',
    render: (text) => text,
  },
  {
    title: 'Cons',
    dataIndex: 'cons',
    align: 'right' as const,
  },
]

const TitleComponent = (name) => {
  const { Title } = Typography
  return <Title level={2}>{`${name} Pros and Cons`}</Title>
}

export default function AcccountOpeningCharges({ pros, cons, name }) {
  const data = []
  const tableLength = pros.length > cons.length ? pros.length : cons.length
  for (let i = 0; i < tableLength; i += 1) {
    data.push({
      key: i,
      pros: pros[i]?.display_text && pros[i]?.display_text,
      cons: cons[i]?.display_text && cons[i]?.display_text,
    })
  }

  return (
    <Table
      columns={columns}
      dataSource={data}
      bordered
      title={() => TitleComponent(name)}
      pagination={false}
    />
  )
}

AcccountOpeningCharges.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pros: PropTypes.object.isRequired,
  cons: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
}
